import { ApolloClient, gql, TypedDocumentNode } from '@apollo/client'
import type {
  UpdateEmployeeMutation,
  UpdateEmployeeMutationVariables
} from './__generated__/UpdateEmployeeMutation'
import { employeeCertificateFragment } from '../fragments/EmployeeCertificateFragment'
import { employeeEducationFragment } from '../fragments/EmployeeEducationFragment'
import { employeeProfileFragment } from '../fragments/EmployeeProfileFragment'
import { employeeWorkProfileFragment } from '../fragments/EmployeeWorkProfileFragment'

const mutation: TypedDocumentNode<
  UpdateEmployeeMutation,
  UpdateEmployeeMutationVariables
> = gql`
  ${employeeCertificateFragment}
  ${employeeEducationFragment}
  ${employeeProfileFragment}
  ${employeeWorkProfileFragment}

  mutation UpdateEmployeeMutation(
    $input: UpdateEmployeeInput!
    $locale: String!
  ) {
    updateEmployee(input: $input) {
      employee {
        createdAt
        educations {
          ...EmployeeEducationFragment
        }
        email
        employeeCertificates {
          ...EmployeeCertificateFragment
        }
        firstName
        gender
        id
        isStudent
        lastName
        lastSeenAt
        mobile
        ocrState
        preferredLanguage
        profile {
          ...EmployeeProfileFragment
        }
        ssn
        state
        updatedAt
        workProfile {
          ...EmployeeWorkProfileFragment
        }
      }
      __typename
    }
  }
`

export function updateEmployeeMutation(
  apolloClient: ApolloClient,
  options: Omit<
    ApolloClient.MutateOptions<
      UpdateEmployeeMutation,
      UpdateEmployeeMutationVariables
    >,
    'mutation'
  >
) {
  return apolloClient.mutate({
    mutation,
    ...options
  })
}
